import axios from 'axios';
import { useAuthStore } from '@/stores/useAuthStore';
import { backend_url } from '@/config/config';

// Création de l'instance
const backendApi = axios.create({
  baseURL: backend_url,
  // Optionnel : timeout raisonnable
  timeout: 30000,
});

// === INTERCEPTOR DE REQUÊTE : ajoute le token automatiquement ===
backendApi.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore();
    if (authStore.token) {
      config.headers.Authorization = `Bearer ${authStore.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// === INTERCEPTOR DE RÉPONSE : gestion 401 + logs propres ===
backendApi.interceptors.response.use(
  (response) => response,

  async (error) => {
    if (error.response) {
      const status = error.response.status;

      if (status === 401) {
        // Token expiré ou invalide → déconnexion automatique
        const authStore = useAuthStore();
        authStore.logout();
        // Optionnel : rediriger vers login si tu as un router
        // router.push('/login');
      }

      if (status === 400) {
        console.warn("Bad Request :", error.response.data?.detail || error.response.data);
      }

      if (status >= 500) {
        console.error("Erreur serveur :", error.response.data);
      }
    } else {
      // Erreur réseau ou timeout
      console.error("Erreur réseau :", error.message);
    }

    return Promise.reject(error);
  }
);

export default backendApi;